// 缓存管理工具
export class CacheManager {
  /**
   * 清除所有本地缓存
   */
  static async clearAllCache(): Promise<void> {
    try {
      console.log('开始清除所有缓存...');
      
      // 1. 清除 localStorage
      localStorage.clear();
      console.log('localStorage 已清除');
      
      // 2. 清除 sessionStorage
      sessionStorage.clear();
      console.log('sessionStorage 已清除');
      
      // 3. 清除 Service Worker 缓存
      if ('serviceWorker' in navigator && 'caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => {
            console.log('删除缓存:', cacheName);
            return caches.delete(cacheName);
          })
        );
        console.log('Service Worker 缓存已清除');
      }
      
      // 4. 清除 IndexedDB 缓存（如果有的话）
      if ('indexedDB' in window) {
        const databases = await window.indexedDB.databases();
        await Promise.all(
          databases.map(db => {
            if (db.name) {
              console.log('删除 IndexedDB:', db.name);
              return window.indexedDB.deleteDatabase(db.name);
            }
          })
        );
        console.log('IndexedDB 缓存已清除');
      }
      
      // 5. 清除浏览器缓存（通过重新加载页面）
      console.log('所有缓存清除完成，准备重新加载页面...');
      
    } catch (error) {
      console.error('清除缓存时发生错误:', error);
      throw error;
    }
  }
  
  /**
   * 清除特定类型的缓存
   */
  static clearLocalStorage(): void {
    localStorage.clear();
    console.log('localStorage 已清除');
  }
  
  static clearSessionStorage(): void {
    sessionStorage.clear();
    console.log('sessionStorage 已清除');
  }
  
  static async clearServiceWorkerCache(): Promise<void> {
    if ('serviceWorker' in navigator && 'caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      console.log('Service Worker 缓存已清除');
    }
  }
  
  /**
   * 获取缓存信息
   */
  static getCacheInfo(): {
    localStorageSize: number;
    sessionStorageSize: number;
    hasServiceWorker: boolean;
  } {
    let localStorageSize = 0;
    let sessionStorageSize = 0;
    
    // 计算 localStorage 大小
    for (let key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        localStorageSize += localStorage[key].length + key.length;
      }
    }
    
    // 计算 sessionStorage 大小
    for (let key in sessionStorage) {
      if (sessionStorage.hasOwnProperty(key)) {
        sessionStorageSize += sessionStorage[key].length + key.length;
      }
    }
    
    return {
      localStorageSize,
      sessionStorageSize,
      hasServiceWorker: 'serviceWorker' in navigator
    };
  }
}
